/**
 * iter632 — Manage hub page (Foodics-style card grid).
 * Single landing for all admin configuration shortcuts.
 */
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../components/DashboardLayout';
import { Card, CardContent } from '../components/ui/card';
import { ChevronRight, Calculator, CreditCard, Receipt, Truck, Tag, AlertCircle, ChefHat, CalendarClock, Globe, Bell, Coins, Settings, Printer, Palette, Sparkles, FileText, Monitor } from 'lucide-react';

const CARDS = [
  { path: '/setup-wizard', icon: Sparkles, label: 'Setup Wizard', badge: 'New' },
  { path: '/monthly-tax-report', icon: FileText, label: 'Monthly Tax Report', badge: 'New' },
  { path: '/print-history', icon: Printer, label: 'Print History', badge: 'New' },
  { path: '/branding', icon: Palette, label: 'Branding & PDF' },
  { path: '/settings/receipt', icon: Receipt, label: 'Receipt Settings' },
  { path: '/printer-setup', icon: Printer, label: 'Printer Setup' },
  { path: '/settings/printers', icon: Printer, label: 'Manage Printers', badge: 'New' },
  { path: '/customer-display/promos', icon: Monitor, label: 'Customer Display Promos', badge: 'New' },
  { path: '/upsells', icon: Sparkles, label: 'Upsell Rules', badge: 'New' },
  { path: '/notifications', icon: Bell, label: 'Notifications', badge: 'New' },
  { path: '/allergens', icon: AlertCircle, label: 'Allergens' },
  { path: '/timed-events', icon: CalendarClock, label: 'Timed Events' },
  { path: '/reservations', icon: CalendarClock, label: 'Reservations' },
  { path: '/settings', icon: Settings, label: 'Settings' },
];

export default function ManageHubPage() {
  const nav = useNavigate();
  return (
    <DashboardLayout>
      <div className="max-w-6xl mx-auto px-4 py-6 space-y-4" data-testid="manage-hub-page">
        <h1 className="text-2xl sm:text-3xl font-bold font-outfit">Manage</h1>
        <p className="text-sm text-muted-foreground -mt-2">
          All your admin shortcuts in one place — pick what to configure.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="manage-hub-grid">
          {CARDS.map((c) => {
            const Icon = c.icon;
            return (
              <Card
                key={c.path}
                onClick={() => nav(c.path)}
                className="cursor-pointer hover:border-indigo-400 hover:shadow-md transition group"
                data-testid={`manage-card-${c.path.replace(/\//g, '-')}`}
              >
                <CardContent className="p-4 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <Icon size={20} className="text-indigo-600 group-hover:scale-110 transition" />
                    <div>
                      <div className="font-semibold text-sm">{c.label}</div>
                      {c.badge && (
                        <span className="text-[9px] uppercase tracking-wide bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded font-bold">{c.badge}</span>
                      )}
                    </div>
                  </div>
                  <ChevronRight size={16} className="text-stone-400 group-hover:text-indigo-600 group-hover:translate-x-0.5 transition" />
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </DashboardLayout>
  );
}
